/** Die Seiten: Anmeldung, Übersicht, Board, Gastzugang, Einmal-Links, Anmeldung von außen. */
export const pages = {
    // --- Anmeldung -------------------------------------------------------------
    'login.lead.default': 'Zugang für Mitglieder einer Organisation.',
    'login.lead.bootstrap': 'Noch kein Konto vorhanden. Dieses erste legt zugleich die Organisation an und führt sie.',
    'login.lead.forgot': 'Trag deine Adresse ein — wir schicken dir einen Link, mit dem du ein neues Passwort setzt.',
    'login.orgPlaceholder': 'Name des Unternehmens',
    'login.namePlaceholder': 'Vor- und Nachname',
    'login.signIn': 'Anmelden',
    'login.createAccount': 'Konto anlegen',
    'login.requestLink': 'Link anfordern',
    'login.forgot': 'Passwort vergessen?',
    'login.backToSignIn': 'Zurück zur Anmeldung',
    'login.whatIsPraesto': 'Was ist Præsto?',
    'login.failed': 'Anmeldung fehlgeschlagen.',
    'login.sent': 'Wenn zu {email} ein Konto besteht, ist eben eine Mail mit einem Link zum Setzen eines neuen Passworts unterwegs. Der Link gilt zwei Stunden.',
    // --- Board-Übersicht -------------------------------------------------------
    'boards.title': 'Boards',
    'boards.lead': 'Whiteboards von {org} — für Konzepte, Moodboards und Kundenpräsentationen.',
    'boards.leadPlain': 'Whiteboards für Konzepte, Moodboards und Kundenpräsentationen.',
    'boards.new': 'Neues Board',
    'boards.loadFailed': 'Boards konnten nicht geladen werden.',
    'boards.copyFailed': 'Board konnte nicht kopiert werden.',
    'boards.switchOrg': 'Organisation wechseln',
    'boards.design': 'Design',
    'boards.designTitle': 'Standard-Design und Schriften dieser Organisation',
    'boards.customers': 'Kunden',
    'boards.customersTitle': 'Alle Kunden, Pakete und Laufzeiten',
    'boards.manual': 'Handbuch',
    'boards.manualTitle': 'Anleitung zu Præsto',
    'boards.accountTitle': 'Eigenes Konto und Passwort',
    'boards.signOut': 'Abmelden',
    'boards.storageUsed': 'belegt in dieser Organisation',
    'boards.storageHidden': ' · davon {size} in Boards, die dir nicht freigegeben sind',
    'boards.emptyTitle': 'Noch kein Board',
    'boards.emptyLead': 'Lege dein erstes Board an, zieh Bilder darauf und zoome dich durch die Präsentation.',
    'boards.wholeOrg': 'Ganze Organisation',
    'boards.private': 'Privat',
    'boards.privateWith': 'Privat · {people}',
    'boards.sizeTitle': 'Belegter Speicher aller Medien dieses Boards, inklusive der erzeugten Auflösungsstufen',
    'boards.duplicateLabel': '{title} duplizieren',
    'boards.duplicateTitle': 'Board kopieren — mit Inhalt, Dateien und Sprechernotizen',
    // Pfad zum Handbuch. Als Text und nicht als Sprachweiche im Code: So steht an
    // einer Stelle, welche Fassung es überhaupt gibt.
    'manual.path': '/handbuch',
    // Die Startseite in dieser Sprache. Beide Adressen leiten nie weiter —
    // anders als `/`, das Angemeldete auf die Übersicht schickt.
    'start.path': '/de/',
    // --- Board -----------------------------------------------------------------
    'board.notFound': 'Dieses Board existiert nicht oder du hast keinen Zugriff darauf.',
    'board.loadFailed': 'Board konnte nicht geladen werden.',
    'board.loading': 'Board wird geladen …',
    'board.toOverview': 'Zur Übersicht',
    'board.guest': 'Gast',
    'board.frameName': 'Frame {number}',
    'board.connection': 'Verbindung: {status}',
    'board.historyTitle': 'Verlauf — frühere Stände dieses Boards ansehen und zurückholen',
    'board.themeTitle': 'Design des Boards — Farben und Schriften',
    'board.share': 'Freigeben',
    'board.present': 'Präsentieren',
    'board.viewOnly': 'Nur Ansicht',
    'board.frameBack': 'Vorheriger Frame',
    'board.frameForward': 'Nächster Frame',
    'board.frameOf': 'Frame {index} von {total}',
    'board.smallScreen': 'Auf diesem Bildschirm nur zum Ansehen.',
    'board.smallScreenAnyway': 'Trotzdem bearbeiten',
    'board.insert.media': 'Medien',
    'board.insert.website': 'Website',
    'board.insert.text': 'Text',
    'board.insert.frame': 'Frame',
    'board.insert.frameTitle': 'Einen Frame anlegen — Format wählen, frei ziehen oder um die Auswahl legen',
    'frame.format.wide': 'Breitbild',
    'frame.format.classic': 'Klassisch',
    'frame.format.square': 'Quadrat',
    'frame.format.post': 'Beitrag',
    'frame.format.story': 'Story',
    'frame.menu.formats': 'Format',
    'frame.menu.draw': 'Frei ziehen',
    'frame.menu.drawHint': 'Auf dem Board einen Rahmen aufziehen',
    'frame.menu.around': 'Um die Auswahl',
    'frame.menu.aroundHint': 'Legt einen Frame um die ausgewählten Objekte',
    'frame.menu.aroundEmpty': 'Dafür zuerst etwas auswählen',
    'frame.draw.hint': 'Rahmen aufziehen — Esc bricht ab',
    'board.insert.template': 'Frame-Vorlage',
    'board.insert.templateTitle': 'Einen gesicherten Frame samt Inhalt einsetzen',
    'board.insert.boardTemplate': 'Boardvorlage',
    'board.insert.boardTemplateTitle': 'Ein Gerüst aus leeren Frames anlegen',
    'board.panHint': 'Ziehen zum Verschieben · ⌘/Strg + Scrollen zum Zoomen',
    'board.uploading.one': 'Datei wird verarbeitet …',
    'board.uploading.many': '{count} Dateien werden verarbeitet …',
    'board.uploadFailed': '„{name}" konnte nicht geladen werden.',
    // --- Demo ------------------------------------------------------------------
    'demo.preparing': 'Die Demo wird vorbereitet …',
    'demo.preparingTalk': 'Der Vortrag wird vorbereitet …',
    'demo.failed': 'Die Demo lässt sich gerade nicht öffnen. Bitte später noch einmal.',
    // --- Vorführung ------------------------------------------------------------
    'showcase.preparing': 'Die Vorführung wird vorbereitet …',
    'showcase.failed': 'Die Vorführung lässt sich gerade nicht öffnen. Bitte später noch einmal.',
    'showcase.bar.text': 'Vorführung — du siehst gerade als Gast zu.',
    'showcase.bar.try': 'Selbst ausprobieren',
    'showcase.bar.about': 'Was ist Præsto?',
    // --- Gastzugang ------------------------------------------------------------
    'guest.hint.explore': 'Du kannst dich frei auf dem Board umsehen. Ändern lässt sich nichts.',
    'guest.hint.guided': 'Die Ansicht folgt dem Vortragenden. Du kannst dich jederzeit lösen und zurückkehren.',
    'guest.hint.locked': 'Du siehst durchgehend das, was der Vortragende gerade zeigt.',
    'guest.linkFailed': 'Der Link konnte nicht geöffnet werden.',
    'guest.nameRequired': 'Bitte gib deinen Namen an.',
    'guest.joinFailed': 'Beitritt fehlgeschlagen.',
    'guest.opening': 'Board wird geöffnet …',
    'guest.yourName': 'Dein Name',
    'guest.namePlaceholder': 'Wie sollen dich die anderen sehen?',
    'guest.enter': 'Board betreten',
    // --- Einmal-Link einlösen --------------------------------------------------
    'redeem.checkFailed': 'Dieser Link konnte nicht geprüft werden.',
    'redeem.mismatch': 'Die beiden Passwörter stimmen nicht überein.',
    'redeem.expiredHint': 'Links gelten nur begrenzt und nur einmal. Fordere über „Passwort vergessen" einen neuen an oder lass dich erneut einladen.',
    'redeem.toSignIn': 'Zur Anmeldung',
    'redeem.invited': 'Du wurdest zu {org} eingeladen. Setz ein Passwort, dann geht es los.',
    'redeem.reset': 'Setz ein neues Passwort für {email}.',
    'redeem.yourName': 'Dein Name',
    'redeem.nameHint': 'So erscheinst du für die anderen im Board.',
    'redeem.start': 'Loslegen',
    'redeem.setPassword': 'Passwort setzen',
    // --- Selbstanmeldung -------------------------------------------------------
    'signup.lead': '14 Tage ausprobieren, ohne Zahlungsdaten. Danach melden wir uns — wer nicht verlängert, verliert nichts sofort.',
    'signup.orgPlaceholder': 'Name deiner Agentur',
    'signup.plan': 'Paket',
    'signup.perMonth': '{price} €/Monat',
    'signup.planSummary': '{members} Personen, {storage}.',
    'signup.switchAnytime': 'Wechseln geht jederzeit.',
    'signup.submit': 'Kostenlos testen',
    'signup.haveAccount': 'Ich habe schon ein Konto',
    'signup.yourOrg': 'deine Organisation',
    'signup.sent': 'Wir haben eine Mail an {email} geschickt. Darin steht ein Link, mit dem du dein Passwort setzt — danach steht {org} bereit.',
    'signup.spamHint': 'Nichts angekommen? Sieh im Spam nach. Der Link gilt zwei Wochen.',
    'signup.backToOverview': 'Zurück zur Übersicht',
    'common.failed': 'Das hat nicht geklappt.',
};
//# sourceMappingURL=pages.js.map